import StoreSettings from "@/models/StoreSettings";

function getSelectedStore(vm: any): StoreSettings {
    return vm.$store.state.store.selectedStoreDetails as StoreSettings;
}

function getCurrentUserAddress(vm: any): any {
    const authState = vm.$store.state.auth || {};
    const currentUserKey = authState.currentUser || "guest";
    const currentUser = authState.listOfUsers ? authState.listOfUsers[currentUserKey] : null;

    return currentUser && currentUser.usedAddress ? currentUser.usedAddress : null;
}

export function getRouteStoreId(vm: any): number {
    const storeId = Number.parseInt(vm.$route.params.storeId, 10);

    return Number.isNaN(storeId) ? 0 : storeId;
}

export function hasSelectedStoreForRoute(vm: any): boolean {
    const selectedStore = getSelectedStore(vm);
    const routeStoreId = getRouteStoreId(vm);

    return routeStoreId > 0 && selectedStore && selectedStore.id === routeStoreId;
}

export async function ensureSelectedStoreForRoute(vm: any): Promise<void> {
    const routeStoreId = getRouteStoreId(vm);

    if (routeStoreId <= 0 || hasSelectedStoreForRoute(vm)) {
        return;
    }

    const address = getCurrentUserAddress(vm);
    const position = address && address.position ? address.position : {};

    await vm.$store.dispatch("store/getStoreDetails", {
        branchId: routeStoreId,
        shopperCoordinates: {
            latitude: position.latitude || 0,
            longitude: position.longitude || 0
        },
        getEligibilityInfo: true
    });
}

export function canUseSelectedStore(vm: any): boolean {
    const selectedStore = getSelectedStore(vm);

    return !!(selectedStore && selectedStore.id);
}